export var TipsRoutes;
(function (TipsRoutes) {
    TipsRoutes["DAILY"] = "/my-tips/daily";
    TipsRoutes["WEEKLY"] = "/my-tips/weekly";
})(TipsRoutes || (TipsRoutes = {}));
